module.exports = __webpack_public_path__ + "static/media/NTC2025-DAY1.604c80a2.jpg";